import { createAction, props } from '@ngrx/store';
import { AssessmentConfig } from 'src/app/shared/utils/assessment-navigator';

// Set a multi-assessment (teacher multiple assessments flow)
export const setMultiAssessment = createAction(
  '[MultiAssessment] Set Assessment',
  props<{ assessment: AssessmentConfig }>()
);

// Set a multi-assessment student
export const setMultiAssessmentStudent = createAction(
  '[MultiAssessment] Set Student',
  props<{
    student: {
      id: number;
      name: string;
      assignment_id: number;
      attempt_id?: number | null;
      interval_id?: number | null;
      age?: string | null;
      ageHolder?: number | null;
      gender?: string | number | null;
      profile_image?: string | null;
      qTypeOverride?: string | null;
      assessmentTitle?: string | null;
      primaryNode?: string | null;
      secondaryNode?: string | null;
      tapOptions?: any[];
      classId?: number | null;
      className?: string | null;
      submissionMode?: string | null;
      sectionItemId?: number | null;
      parentSectionId?: number | null;
      parentName?: string | null;
      schoolId?: number | null;
      school_id?: number | null;
      assessmentId?: number | null;
      assessment_id?: number | null;
      sectionIds?: number[] | string | null;
    };
  }>()
);

// Set section ids for the active assessment layers navigation
export const setMultiAssessmentSectionIds = createAction(
  '[MultiAssessment] Set Section Ids',
  props<{ sectionIds: number[] | string | null }>()
);

// Reset multi-assessment selection
export const resetMultiAssessment = createAction('[MultiAssessment] Reset');
